export default __webpack_public_path__ + "static/media/ceo.eab5a978.jpg";